export const onlyCnpjDigits = (value = '') => String(value).replace(/\D/g, '').slice(0, 14);

export const formatCnpj = (value = '') => onlyCnpjDigits(value)
  .replace(/^(\d{2})(\d)/, '$1.$2')
  .replace(/^(\d{2})\.(\d{3})(\d)/, '$1.$2.$3')
  .replace(/\.(\d{3})(\d)/, '.$1/$2')
  .replace(/(\d{4})(\d)/, '$1-$2');

export const isValidCnpj = (value) => {
  const cnpj = onlyCnpjDigits(value);
  if (cnpj.length !== 14 || /^(\d)\1+$/.test(cnpj)) return false;
  const digit = (base, weights) => {
    const sum = weights.reduce((total, weight, index) => total + Number(base[index]) * weight, 0);
    const remainder = sum % 11;
    return remainder < 2 ? 0 : 11 - remainder;
  };
  return Number(cnpj[12]) === digit(cnpj, [5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2])
    && Number(cnpj[13]) === digit(cnpj, [6, 5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2]);
};

export const onlyCpfCnpjDigits = (value = '') => String(value).replace(/\D/g, '').slice(0, 14);

export const formatCpfCnpj = (value = '') => {
  const digits = onlyCpfCnpjDigits(value);
  if (digits.length <= 11) {
    return digits
      .replace(/^(\d{3})(\d)/, '$1.$2')
      .replace(/^(\d{3})\.(\d{3})(\d)/, '$1.$2.$3')
      .replace(/\.(\d{3})(\d)/, '.$1-$2');
  }
  return formatCnpj(digits);
};

export const isValidCpf = (value) => {
  const cpf = onlyCpfCnpjDigits(value);
  if (cpf.length !== 11 || /^(\d)\1+$/.test(cpf)) return false;
  const digit = (length) => {
    const sum = cpf.slice(0, length).split('')
      .reduce((total, current, index) => total + Number(current) * (length + 1 - index), 0);
    const remainder = (sum * 10) % 11;
    return remainder === 10 ? 0 : remainder;
  };
  return Number(cpf[9]) === digit(9) && Number(cpf[10]) === digit(10);
};

export const isValidCpfCnpj = (value) => {
  const digits = onlyCpfCnpjDigits(value);
  return digits.length === 11 ? isValidCpf(digits) : digits.length === 14 && isValidCnpj(digits);
};
